import { useState, useEffect } from "react";
import { Phone, List, X } from "@phosphor-icons/react";
import { COMPANY } from "@/lib/constants";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Benefits", href: "#benefits" },
    { label: "Situations", href: "#situations" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-stone-50/85 border-b border-stone-200/60 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="py-4 px-6 md:px-12 lg:px-16 max-w-7xl mx-auto flex justify-between items-center">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-emerald-600 flex items-center justify-center">
            <span className="font-heading font-bold text-white text-lg">F</span>
          </div>
          <span className="font-heading font-bold text-lg text-slate-900 hidden sm:block">
            {COMPANY.name}
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-emerald-700 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={COMPANY.phoneHref}
            data-testid="phone-cta-header"
            className="hidden sm:flex items-center gap-2 text-emerald-700 hover:text-emerald-800 font-bold text-base md:text-xl transition-colors"
          >
            <Phone weight="fill" className="h-5 w-5" />
            {COMPANY.phoneDisplay}
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-slate-900"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <List className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-stone-50 border-t border-stone-200 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-slate-700"
            >
              {l.label}
            </a>
          ))}
          <a href={COMPANY.phoneHref} className="flex items-center gap-2 text-emerald-700 font-bold text-lg">
            <Phone weight="fill" className="h-5 w-5" />
            {COMPANY.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};
